import React, { useCallback } from 'react';

interface IToastExecuterProps {
    customEventName: 'executeBasketToastNotification' // place for union type
}
export const useToastExecuter = ({ customEventName }: IToastExecuterProps) => {
    const handleShowToast = useCallback(
        () => {
            document.dispatchEvent(new Event(customEventName));
        },
        [customEventName],
    );

    return [handleShowToast];
};
